import React from "react";

const AchievementSlider = () => {
  const achievements = [
    { image: "/award1.png" },
    { image: "/award2.png" },
    { image: "/award3.png" }
  ];

  return (
    <section className="py-14 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Our Achievements
        </h2>

        {/* Images Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {achievements.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition duration-300 p-6 flex items-center justify-center"
            >
              <img
                src={item.image}
                alt={`Achievement ${index + 1}`}
                className="h-40 object-contain hover:scale-110 transition duration-500"
              />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AchievementSlider;